import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Могу ли я изменить план в любое время?",
      answer: "Да, вы можете повысить или понизить свой план в любое время. При повышении плана изменения вступают в силу немедленно, при понижении — с начала следующего расчетного периода. Неиспользованная сумма будет пропорционально зачтена."
    },
    {
      question: "Что происходит после окончания бесплатного пробного периода?",
      answer: "После окончания 14-дневного пробного периода вы можете выбрать подходящий платный план или продолжить использовать бесплатную версию с ограниченным функционалом. Мы отправим напоминание за 3 дня до окончания пробного периода."
    },
    {
      question: "Какие способы оплаты вы принимаете?",
      answer: "Мы принимаем все основные банковские карты (Visa, Mastercard, МИР), банковские переводы для корпоративных клиентов, а также электронные кошельки. Для Enterprise планов доступна оплата по счету с отсрочкой платежа."
    },
    {
      question: "Есть ли скидки при годовой оплате?",
      answer: "Да, при выборе годовой оплаты вы получаете скидку 20% по сравнению с ежемесячной оплатой. Например, план Professional при годовой оплате обойдется в 758 400 ₸ вместо 948 000 ₸."
    },
    {
      question: "Что включено в техническую поддержку?",
      answer: "Все планы включают email поддержку в рабочие часы. Professional план добавляет приоритетную поддержку с временем ответа до 4 часов. Enterprise план включает выделенного менеджера, телефонную поддержку 24/7 и SLA гарантию 99.9%."
    },
    {
      question: "Можно ли интегрировать Jetu AI с существующими системами?",
      answer: "Да, Jetu AI предлагает интеграцию с популярными CRM системами, мессенджерами (WhatsApp, Telegram, Instagram) и другими бизнес-инструментами. Professional и Enterprise планы включают API доступ для кастомных интеграций."
    },
    {
      question: "Как обеспечивается безопасность данных?",
      answer: "Мы используем шифрование данных по стандарту AES-256, соответствуем требованиям GDPR и храним данные на защищенных серверах в Казахстане. Enterprise план включает дополнительные опции безопасности, включая SSO и аудит доступа."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="bg-card rounded-2xl p-8 border border-border">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-headline font-bold text-foreground mb-2">
          Часто задаваемые вопросы
        </h3>
        <p className="text-muted-foreground">
          Ответы на популярные вопросы о тарифах и функциях
        </p>
      </div>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-xl overflow-hidden transition-all duration-200 hover:border-accent/50"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-5 text-left bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              <span className="font-semibold text-foreground pr-4">
                {faq?.question}
              </span>
              <div className={`flex-shrink-0 transition-transform duration-200 ${
                openIndex === index ? 'rotate-180' : ''
              }`}>
                <Icon name="ChevronDown" size={20} color="currentColor" />
              </div>
            </button>
            
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <div className="p-5 bg-background">
                <p className="text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 p-6 bg-gradient-to-br from-accent/10 to-primary/10 rounded-xl border border-accent/20">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-accent rounded-xl flex items-center justify-center">
            <Icon name="MessageSquare" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h4 className="font-headline font-semibold text-foreground mb-2">
              Не нашли ответ на свой вопрос?
            </h4>
            <p className="text-muted-foreground text-sm mb-4">
              Наша команда поддержки готова помочь вам с любыми вопросами о тарифах, функциях и интеграции.
            </p>
            <a
              href="/contact-support"
              className="inline-flex items-center gap-2 text-accent hover:text-accent/80 font-medium transition-colors"
            >
              <span>Связаться с поддержкой</span>
              <Icon name="ArrowRight" size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;